import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CacheInterceptor } from './app/interceptors/cache.interceptor';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideHttpClient(),//withInterceptors([CacheInterceptor])),
    ...(appConfig.providers || [])
  ]
}).catch(err => console.error(err));
